import apiClient from 'src/utils/apiClient';
import ProcessingMessage from 'src/types/processingMessage';
import { SiteWebhook, SiteWebhookCreateOrUpdate } from '../types';

class WebHookService {
  /** Get SiteWebhooks for given site id */
  public async getSiteWebhooks(siteId: number): Promise<SiteWebhook[]> {
    const response = await apiClient.get(`/sites/${siteId}/siteWebhooks`);
    return response.data;
  }

  /** Create or update a list of SiteWebhook resources */
  public async postSiteWebhooks(data: SiteWebhookCreateOrUpdate[]): Promise<ProcessingMessage[]> {
    const response = await apiClient.post(`/sites/siteWebhooks`, data);
    return response.data;
  }

  /** Delete site webhooks with the given IDs */
  public async deleteSiteWebhooks(webhookIds: number[]): Promise<boolean> {
    const response = await apiClient.post(`/sites/siteWebhooks/deleteRequests`, webhookIds);
    return response?.status === 204;
  }
}

export default new WebHookService();
